export default "__VITE_ASSET__CBPX1NbC__"